import { ReferenciaDoAviso } from '../../api/notificationsApi';
import { DASHBOARD_COMPRAS_ITEM } from '../../views/dashboard_compras/routes';
import { PREVISAO_PECAS_PEDIDO } from '../../views/previsao_pecas/routes';

/**
 * Para onde leva um aviso que aponta para um item: pedido ou requisição do Dashboard de Compras
 * (at-129) ou pedido da Previsão de Peças (aviso "peça chegou", previsao-pecas/at-02).
 *
 * ⚠️ Regra única: o clique no aviso, o link "Abrir…" da lista e o rótulo do toast leem daqui.
 * Com uma cópia em cada ponto, o aviso de peça chegou abriria o Dashboard de Compras num deles.
 */
export function enderecoDaReferencia(tipo: ReferenciaDoAviso, id: string): string {
  if (tipo === 'PEDIDO_PREVISAO') return PREVISAO_PECAS_PEDIDO(encodeURIComponent(id));
  return DASHBOARD_COMPRAS_ITEM(tipo, id);
}

export function rotuloDaReferencia(tipo: ReferenciaDoAviso): string {
  return tipo === 'REQUISICAO' ? 'Abrir requisição' : 'Abrir pedido';
}
